import {JsonProperty} from 'json-typescript-mapper/index';

export class Assortment {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('keyNumber')
  public keyNumber?: string;

  @JsonProperty('industrialCode')
  public industrialCode?: string;

  @JsonProperty('title')
  public title?: string;

  public checked = false;

  constructor() {
    this.id = void 0;
    this.keyNumber = void 0;
    this.industrialCode = void 0;
    this.title = void 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/assortment.model.ts